import { render, staticRenderFns } from "./ProductSku.vue?vue&type=template&id=44c1575a&"
import script from "./ProductSku.vue?vue&type=script&lang=ts&"
export * from "./ProductSku.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports